import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { PenaltyRow } from "./PenaltyRow";

const HEADS = ["index", "serial", "employee", "type", "reason", "amount", "settlement", "status", "effective", "actions"];

// جدول العقوبات (قابل للتمرير أفقياً على الجوال).
export const PenaltyTable = ({ rows, ...handlers }) => {
  const { t } = useTranslation();
  if (!rows.length) {
    return (
      <NeuCard className="p-6 text-center text-sm text-muted-foreground" data-testid="penalty-empty">
        {t("penalty.empty")}
      </NeuCard>
    );
  }
  return (
    <NeuCard className="grid gap-3 p-4" data-testid="penalty-table">
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-base font-black">{t("penalty.listTitle")}</h2>
        <span className="text-xs text-muted-foreground">{t("penalty.showingCount", { n: rows.length })}</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[980px] text-start">
          <thead>
            <tr className="border-b border-border/60">
              {HEADS.map((head) => (
                <th key={head} className="p-2 text-start text-[11px] font-black text-muted-foreground">
                  {t(`penalty.table.${head}`)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <PenaltyRow key={row.penalty_id} row={row} index={index} {...handlers} />
            ))}
          </tbody>
        </table>
      </div>
    </NeuCard>
  );
};
